import { Column } from 'primereact/column'
import { useState, useEffect, useRef, useImperativeHandle, forwardRef } from 'react';
import EditIssueAuthorization from './editIssueAuthorization';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import BaseService from '../../../services/BaseService';
import CommonService from "../../../services/CommonService";
import DataGrid from '../../GenericComponents/DataGrid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';

const NewIssueAuthorizations = forwardRef((props, ref) => {
  const {cdiacNumber, onDataFetch, reportId, reportType, tableType} = props;
  const [isLoading, setIsLoading] = useState(true);
  const [newIssueAuthorizations, setNewIssueAuthorizations] = useState([]); //New issue authorizations in Review table
  const [editIssueAuths, setEditIssueAuths] = useState(false);
  const [selectedIssueAuthInfo, setSelectedIssueAuthInfo] = useState([]);


  const viewEditFormatter = (row) => {
      return (
        <div style={{
          textAlign: "center",
          lineHeight: "normal"
        }}>
          <FontAwesomeIcon icon={faPencilAlt} className="custom-icon" onClick={(e)=>onRowClick(e, row)}/> 
        </div>
      );
    }

    const onRowClick = (e, row) => {
      // e.preventDefault();
      setSelectedIssueAuthInfo(row);
      setEditIssueAuths(true);
    }


  const handleModalClose = () => {
    setEditIssueAuths(false);
    getNewIssueAuthorizationsById(reportId);
  }


  useEffect(() => {
    if (reportId){
      getNewIssueAuthorizationsById(reportId);
    }
   
  }, [reportId]);


  const getNewIssueAuthorizationsById = (selectedId) => {
    var obj = {
      msgId: null,
      sysId: null,
      opr: "getAuthorizationsByReportId", 
      hdrStruct: null,
      queryParam: null,
      reqData: {
        "id": selectedId,
        "reportType": reportType,
        "tableType": tableType,
      },
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        Object.keys(result.data.responses).forEach((key) => {
          setNewIssueAuthorizations(result.data.responses[key]);
          onDataFetch(result.data.responses[key]);
        });
        setIsLoading(false);

      });
  }

  
  useImperativeHandle(ref, () => {
      return {
        getNewIssueAuthorizationsById
      };
  }, [])


  const  columnsNewIssueAuthorizations = [{
    dataField: 'authorizationName',
    text: 'Authorization Name',
    sort: true,
  }, {
    dataField: 'authorizationDate',
    text: 'Authorization Date',
    sort: true,
    formatter: (row)=> CommonService.dateFormatter(row.authorizationDate),
  }, {
    dataField: 'originalAuthorizedAmt',
    text: 'Original Authorized Amount',
    sort: true,
    formatter: (row)=> CommonService.currencyFormatter(row.originalAuthorizedAmt),
  }, {
    dataField: 'authorityReducedAmt',
    text: 'Authority Reduced Amount',
    sort: true,
    formatter: (row)=> CommonService.currencyFormatter(row.authorityReducedAmt),
  }, {
    dataField: 'authorityReplenishAmt',
    text: 'Authority Replenish Amount',
    sort: true,
    formatter: (row)=> CommonService.currencyFormatter(row.authorityReplenishAmt),
  }, {
    dataField: "",
    text: "Action",
    formatter: viewEditFormatter,
  }
  ];


  return (
    <div>
      <div>
        <DataGrid
          title="New Issue Authorizations:"
          dataSource={newIssueAuthorizations}
          sortField='authorizationId'
          showQuickSearch={false}
          emptyDataMessage='No data available to display'
        >
          {columnsNewIssueAuthorizations.map((column, i) => {
            return (
              <Column
                key={i}
                field={column.dataField}
                header={column.text}
                sortable={column.sort}
                body={column.formatter}
                hidden={column.hidden}
              />)
          })
          }
        </DataGrid>
      </div>
      <div>
        {editIssueAuths && <EditIssueAuthorization onModalClose={handleModalClose} issueAuthInfo={selectedIssueAuthInfo} cdiacNumber={cdiacNumber} tableType={tableType} />}
      </div>
    </div>

  )
});

export default NewIssueAuthorizations;

